import Udesk from 'Udesk';
import Component from "./template";
import { Form } from "@ant-design/compatible";
export default Form.create()(Udesk.react.udeskify(Component));
